import React from 'react';
import PropTypes from 'prop-types';

const PLACEHOLDER_SYMBOL = 'placeholder';
const DEFAULT_SYMBOL_SIZE = 'default';

export default function Icon({ symbol, size, style, className }) {
    const isPlaceholder = symbol === PLACEHOLDER_SYMBOL;
    // Finally fixed this for IE11 as well:
    // https://github.com/facebook/react/issues/2250#issuecomment-163710327
    const xlinkHref = isPlaceholder ? `#${ PLACEHOLDER_SYMBOL }` : `#${ size }--${ symbol }`;
    className = `icon icon__${ size } ${ className }`;

    return (
        <svg tabIndex="-1" style={style} className={className} focusable="false">
            <use xlinkHref={xlinkHref}/>
        </svg>
    );
}

Icon.propTypes = {
    // symbol key (required)
    symbol: PropTypes.string.isRequired,
    // optional classname (can contain styling)
    className: PropTypes.string,
    style: PropTypes.object,
    // optional standardized size e.g. "sm"
    size: PropTypes.string,
};

Icon.defaultProps = {
    displayName: 'Icon', // little hack here becuase the Component.displayName doesn't seem to work
    symbol: PLACEHOLDER_SYMBOL,
    className: '',
    style: {},
    size: DEFAULT_SYMBOL_SIZE,
};




// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/icon/index.js